import _tcLib from "./timecode.js";
/**
 * Media ↔ wall/incode conversion helpers.
 *
 * Pulldown rates (23.976/23.98, NDF 29.97/59.94): incode labels use media SMPTE
 * (e.g. 01:00:00:00 @ 23.976 → 3603.6s = 86400 × 1001/24000).
 * Integer rates and DF 29.97/59.94: wall-clock parse/format.
 */

const tcLib = _tcLib;
function parseRate(frameRate) {
  return parseFloat(frameRate);
}

/**
 * NTSC rates where media time and wall-clock labels diverge (~1.001).
 */
function isNtscPulldownRate(frameRate, dropFrame) {
  const fr = parseRate(frameRate);
  if (fr === 23.976 || fr === 23.98) {
    return true;
  }
  if ((fr === 29.97 || fr === 59.94) && !dropFrame) {
    return true;
  }
  return false;
}

/** Media seconds → wall-clock seconds (for calcTc *Clock ms fields). */
function applyPulldownDivider(sec, frameRate, dropFrame) {
  if (!isNtscPulldownRate(frameRate, dropFrame)) {
    return sec;
  }
  return tcLib.tcClockToSec(tcLib.secToTc(sec, frameRate, dropFrame), frameRate);
}

/** Wall-clock seconds → media seconds (inverse of applyPulldownDivider). */
function applyPulldownMultiplier(sec, frameRate, dropFrame) {
  if (!isNtscPulldownRate(frameRate, dropFrame)) {
    return sec;
  }
  return tcLib.tcToSec(tcLib.secToTcClock(sec, frameRate), frameRate, dropFrame);
}

/**
 * Convert an incode HH:MM:SS:FF label to media seconds (projectState.incode units).
 */
function incodeLabelToMediaSeconds(tc, frameRate, dropFrame) {
  const fr = parseRate(frameRate);
  if (isNtscPulldownRate(fr, dropFrame)) {
    return parseFloat(Number(tcLib.tcToSec(tc, fr, dropFrame, false)).toFixed(3));
  }
  return parseFloat(Number(tcLib.tcToSec(tc, fr, dropFrame, true)).toFixed(3));
}

/**
 * Convert stored media seconds to the incode label shown/edited in the UI.
 */
function mediaSecondsToIncodeLabel(sec, frameRate, dropFrame) {
  const fr = parseRate(frameRate);
  if (isNtscPulldownRate(fr, dropFrame)) {
    return tcLib.secToTc(sec, fr, dropFrame);
  }
  return tcLib.secToTcClock(sec, fr, dropFrame);
}

/**
 * Remap incode for encode/decode when Use Clock Time is "no".
 * Media seconds → secToTcClock(mediaSec) for the string addIncode expects.
 */
function remapIncodeForNonClockPipeline(tc, frameRate, dropFrame) {
  const mediaSec = incodeLabelToMediaSeconds(tc, frameRate, dropFrame);
  return tcLib.secToTcClock(mediaSec, frameRate, dropFrame);
}
export default {
  isNtscPulldownRate,
  applyPulldownMultiplier,
  applyPulldownDivider,
  incodeLabelToMediaSeconds,
  mediaSecondsToIncodeLabel,
  remapIncodeForNonClockPipeline
};